import React from "react";
import styles from "./styles";
import { withStyles } from "@material-ui/core/styles";
import Form from "./Form";
import ShipmentDetails from "../../common/ShipmentDetails";
import appConstants from "../../../../../../../appConstants";
import { getDeliveryLiftgateReasonValidationError, isLiftgateChecked } from "../../common/liftgateUtils";
import { getDeliverySortAndSegregateValidationError, isSortAndSegregateChecked } from "../../common/sortAndSegregateUtils";
import { getPhysicalPiecesValidationError } from "../../common/physicalPiecesUtils";
import { PAYMENT_MODES } from "../../common/constants";
import { observer, inject } from "mobx-react";
import ShipmentCard from "./ShipmentsCard";
import { withSnackbar } from "notistack";
import { StyledRadioGroup } from "../../common/RadioGroup";
import { withUserProfile } from "../../../../../../../userProfile/userProfileContext";
import { compose } from "recompose";
import CustomConfirmationDialog from "../../common/CustomConfirmationDialog";
import {
  getDefaultDeliveryStopInfo,
  getDefaultStopTimeInfo,
  getStopTimeErrorInfo,
  isStopTimeDetailsInValid,
  getStopTimeFieldError,
  getShipmentFreightBill,
  getExcessiveLengthError,
} from "../util";
import { getPendingStops, formatDeliveryOrServiceWindow } from "../../../../utils/utils";
import StopDetailsTitle from "../../common/StopDetailsTitle";
import SwitchWithLabel from "../../common/CustomSwitch";
import Action from "../common/Action";
import StopWindowDetails from "../../common/StopWindowDetails";
import { getDateWithUtcHoursAndMinFromTimeString,convertDateTimeToTimeString  } from '@dataGrid/gridUtilities';
import SelectBills from "./SelectBills";
import { getAccessorialsAfterExclusion } from "./../../common/AccessorialUtils";
import {
  getPaymentErrorInfo,
  isPaymentDetailsRequired,
  populatePaymentAmount,
} from "./../Payment/util";
import { withExceptionDetailsHOC } from "./ExceptionDetails/withExceptionDetailsHOC";
import { isEqual } from "lodash/lang";
import { withAppConfig } from "@appConfigContext";
import { getCombinedExcessiveLength } from "../../utils";
import MESSAGES from "../../../../../../../appMessages";
import ReturnDetails from "./ReturnDetails";

@inject("DispatchStore")
@observer
class ProcessDelivery extends React.Component {
  constructor(props) {
    const {
      processDeliveryData,
      deliveryException,
      stopData: { actualArrivalTime, actualDepartureTime, isStopCompleted },
    } = props;
    super(props);
    this.state = {
      editBillsDataArray:
        processDeliveryData?.editBillsDataArray ??
        getDefaultDeliveryStopInfo({
            stopData: this.props.stopData,
            getDefaultExceptionDetail: deliveryException.getDefaultExceptionDetail,
            getAccessorialsArray: this.getDefaultAccessorialsArray,
          }),
      errorMessage: null,
      allStatusRadioClicked:
        processDeliveryData?.allStatusRadioClicked ?? false,
      showConfirmDialog: false,
      showDeliveryReceipt: false,
      isDriverAllowedInside: processDeliveryData?.isDriverAllowedInside ?? true,
      stopTimeInfo:
        processDeliveryData?.stopTimeInfo ??
        getDefaultStopTimeInfo({
          isDriverArrived: props.isDriverArrived, 
          actualArrivalTime, 
          departureTime: actualDepartureTime, 
          isStopCompleted
        }),
      editStopsList: [this.props.stopData],
      isArrivalDepartureTimeRequired: true,
      hasAnyProFormBeenOpened: false, // Track if any pro form has been opened at least once
    };
    this.inputRefs = [];
  }
  setRef = (ref) => {
    this.inputRefs.push(ref);
  };

  handleProFormExpand = (proId, isExpanded) => {
    if (isExpanded) {
      // Once any form is opened, permanently disable global return flow
      this.setState({ hasAnyProFormBeenOpened: true });
    }
  };

  componentDidUpdate(prevProps) {
    const {
      isDriverArrived,
      stopData,
      deliveryException
    } = this.props;
    if (isDriverArrived !== prevProps.isDriverArrived) {
      this.setNewArrivalStopTime();
    }
    if (stopData.isStopCompleted && !isEqual(stopData ,prevProps.stopData)){
      this.setState({
        editBillsDataArray: getDefaultDeliveryStopInfo({
          stopData,
          getDefaultExceptionDetail: deliveryException.getDefaultExceptionDetail,
          getAccessorialsArray: this.getDefaultAccessorialsArray,
        })
      });
    }
  }

  setNewArrivalStopTime = () => {
    const {
      isDriverArrived,
      stopData: { actualArrivalTime },
    } = this.props;
    this.setState((prevState) => ({
      ...prevState,
      stopTimeInfo: {
        ...prevState.stopTimeInfo,
        stopTime: {
          ...prevState.stopTimeInfo.stopTime,
          arrivalTime:
            isDriverArrived && actualArrivalTime
              ? getDateWithUtcHoursAndMinFromTimeString(actualArrivalTime)
              : null,
        },
      },
    }));
  };

  clearSelections = (proId) => {
    let newBillList = [];
    this.state.editBillsDataArray.forEach((pro) => {
      if (pro.proId === proId) {
        let editInfo = {
          ...pro.editInfo,
          exceptionType: "",
          returnCode: "",
          customerName: null,
          exception: this.props.deliveryException.getDefaultExceptionDetail(),
        };
        newBillList.push({ ...pro, editInfo: editInfo, errorInfo: {} });
      } else {
        newBillList.push({ ...pro });
      }
    });
    this.setState({
      editBillsDataArray: newBillList,
      editStopsList: [this.props.stopData],
    });
  };

  resetReturnCodeFields = (fieldName, value) => {
    switch (fieldName) {
      case "returnCode":
        return {
          customerName: null,
          exception: this.props.deliveryException.getDefaultExceptionDetail(),
        };
      case "deliveryStatus":
        return [appConstants.DELIVERY_CODE.SND, appConstants.DELIVERY_CODE.RTN].includes(value) 
          ? {
              isShrinkWrap: false,
              palletCount: null,
              isPhysicalPiecesChanged: false,
              physicalPiecesHandled: null,
              isExcessiveLength: appConstants.EXCESSIVE_SHIPMENT.NO,
              excessiveLength: null,
            }
          : {
              isShrinkWrap: false,
              isPhysicalPiecesChanged: false,
              physicalPiecesHandled: null,
              returnCode: null
            };
      case "isExcessiveLength":
        return { excessiveLength: null, excessiveLengthInches : null };
      case "isShrinkWrap":
        return { palletCount: null };
      case "isPhysicalPiecesChanged":
        return { physicalPiecesHandled: null };
      default:
        return {};
    }
  };

  handleChange = (proId) => (name) => (value) => {
    let newBillList = [],
      populatedPaymentInfo = {};
    this.state.editBillsDataArray.forEach((pro) => {
      if (pro.proId === proId) {
        let resetFrieghtCheckNumber = null;
        if (["freightPaymentType", "codPaymentType"].includes(name)) {
          const shipmentObj = this.getShipmentData(proId);
          populatedPaymentInfo = populatePaymentAmount({
            freightAmount: shipmentObj?.freightAmount,
            codAmount: shipmentObj?.codAmount,
            paymentTypeFieldName: name,
            paymentTypeValue: value,
          });
        }

        if (
          name === "freightPaymentType" &&
          value.value !== PAYMENT_MODES.FREIGHT_PAYMENT_MODES.CHECK
        ) {
          resetFrieghtCheckNumber = { freightCheckNumber: null };
        }

        let editInfo = {
          ...pro.editInfo,
          ...populatedPaymentInfo,
          ...this.resetReturnCodeFields(name, value),
          ...resetFrieghtCheckNumber,
          [name]: value,
        };
        if (
          name === "accessorials" &&
          !isSortAndSegregateChecked(value, appConstants.ACCESSORIAL.SORT_AND_SEGREGATE)
        ) {
          editInfo.sortAndSegregatePieces = null;
        }
        if(["excessiveLengthInches","excessiveLength"].includes(name)){
          value = getCombinedExcessiveLength(editInfo.excessiveLength, editInfo.excessiveLengthInches);
          if(name == "excessiveLengthInches")
            name = "excessiveLength"
        }
        
        let errorInfo = {
          ...pro.errorInfo,
          [name]: this.getFieldError(proId, name, value),
        };

        if (name === 'isExcessiveLength') {
          errorInfo = { ...errorInfo, excessiveLength: null, excessiveLengthInches: null };
        }
        newBillList.push({ ...pro, editInfo: editInfo, errorInfo: errorInfo });
      } else {
        newBillList.push({ ...pro });
      }
    });
    const isArrivalDepartureTimeRequired = this.getIsArrivalDepartureTimeRequired(newBillList);
    this.setState(
      (prevState) => ({
        editBillsDataArray: newBillList,
        isArrivalDepartureTimeRequired,
        stopTimeInfo: this.getUpdatedStopTimeInfo(
          isArrivalDepartureTimeRequired,
          prevState
        ),
      }),
      () => {
        if (name === "deliveryStatus") {
          this.clearSelections(proId);
        }
      }
    );
  };

  getUpdatedStopTimeInfo = (isArrivalDepartureTimeRequired, prevState) => {
    const {
      stopData: { actualArrivalTime, actualDepartureTime, isStopCompleted },
      isDriverArrived
    } = this.props;
    if (isArrivalDepartureTimeRequired || isStopCompleted) {
      return isDriverArrived
        ? getDefaultStopTimeInfo(
            {isDriverArrived,
              actualArrivalTime,
              departureTime: convertDateTimeToTimeString(this.state.stopTimeInfo.stopTime.departureTime) || actualDepartureTime,
            isStopCompleted}
          )
        : prevState.stopTimeInfo;
    }
    return getDefaultStopTimeInfo();
  };

  getIsArrivalDepartureTimeRequired = (billsData) => {
    // if atleast one of the pro needs arrivalDeparture time
    return billsData.reduce((isArrivalDepartureTimeRequired, proData) => {
      let isArrivalDepartureTimeRequiredForPro = true;
      if (proData.editInfo.exceptionType) {
        isArrivalDepartureTimeRequiredForPro =
          this.props.DispatchStore.getExceptionDetails(
            proData.editInfo.exceptionType
          )?.isArrivalDepartureTimeRequired;
      } else if (proData.editInfo.returnCode) {
        isArrivalDepartureTimeRequiredForPro =
          this.props.DispatchStore.getReturnDetails(
            proData.editInfo.returnCode
          )?.isArrivalDepartureTimeRequired;
      }
      return (
        isArrivalDepartureTimeRequired || isArrivalDepartureTimeRequiredForPro
      );
    }, false);
  };

  handleIsDriverAllowedChange = (value) => {
    this.setState({
      isDriverAllowedInside: value,
    });
  };

  handleStopTimeChange = (name) => (value) => {
    const stopTime = {
      ...this.state.stopTimeInfo.stopTime,
      [name]: value
    };
    const prevStopTimeError = this.state.stopTimeInfo.stopTimeError;
    const stopTimeError = {
      arrivalTime:
        name === 'arrivalTime'
          ? getStopTimeFieldError({
            field: 'arrivalTime',
            value: stopTime.arrivalTime,
            stopTimeInfo: stopTime,
            isStopCompleted: this.props.stopData.isStopCompleted
          })
          : prevStopTimeError.arrivalTime,
      departureTime:
        name === 'departureTime' || stopTime.departureTime
          ? getStopTimeFieldError(
            {
              field: 'departureTime',
              value: stopTime.departureTime,
              stopTimeInfo: stopTime,
              isStopCompleted: this.props.stopData.isStopCompleted
            })
          : prevStopTimeError.departureTime
    };
    this.setState({
      stopTimeInfo: {
        stopTime,
        stopTimeError
      }
    });
  };

  submitAllProsOnConfirm = () => {
    let newBillList = [];
    this.state.editBillsDataArray.forEach((pro) => {
      let editInfo = {
        ...pro.editInfo,
        deliveryStatus: this.state.allProDelStatusCode,
      };
      newBillList.push({ ...pro, editInfo: editInfo, errorInfo: {} });
    });
    this.setState({
      editBillsDataArray: newBillList,
      showConfirmDialog: false,
    });
  };

  updateStopSelection = (selectedStops) => {
    this.setState({ editStopsList: [...selectedStops] });
  };

  getPaymentDetailsObject = (editInfo) => {
    return {
      freightAmount: editInfo.freightAmountCollected,
      freightCheckNumber: editInfo.freightCheckNumber,
      codAmount: editInfo.codAmountCollected,
      codCheckNumber: editInfo.codCheckNumber,
      codPaymentType: editInfo.codPaymentType?.value ?? null,
      freightPaymentType: editInfo.freightPaymentType?.value ?? null,
    };
  };

  getDeliveryStatus = (value) => {
    return this.props.DispatchStore.deliveryStatuses.find(
      (item) => item.value === value
    )?.labelText;
  };

  cancelStopCompletion = () => {
    this.setState({
      showConfirmDialog: false,
    });
  };

  allProsMarkedTA = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.TA
    );
  };

  getOtherStopsData = (stop) => {
    return stop.shipments.map((shipment) => ({
      editProData: {
        proNumber: shipment.proId,
        accessorials: [],
        palletCount: null,
        isShrinkWrap: null,
        isPhysicalPiecesChanged: false,
        physicalPiecesHandled: null,
        excessiveLength: null,
        deliveryCode: appConstants.DELIVERY_CODE.TA,
      },
      shipmentData: shipment,
    }));
  };

  getAccessorialsArray = (editInfo) => {
    if ([appConstants.DELIVERY_CODE.SND, appConstants.DELIVERY_CODE.RTN].includes(editInfo.deliveryStatus)) {
      return [];
    }
    const { accessorialExclusionList } =
      this.props.DispatchStore.getStaticClientData().clientCodes;
    const selectedAccessorials = editInfo.accessorials
      .filter((accessorial) => accessorial.isChecked)
      .map((accessorial) => accessorial.name);
    return selectedAccessorials.length === 0
      ? selectedAccessorials
      : getAccessorialsAfterExclusion(this.props.configJSON.proValidation)({
          selectedAccessorials,
          accessorialExclusionList,
          isLiftgateTrailer: this.props.routeData.trailer.isLiftGate,
        });
  };

  getDefaultAccessorialsArray = (accessorials) => {
    return this.props.DispatchStore.deliveryAccessorials.map((accessorial) => {
      return {
        ...accessorial,
        isChecked: accessorials?.includes(accessorial.name) || false
      };
    });
  };

  populateRequestObj = (data) => {
    const { editInfo, proId } = data;
    let editProData = {};
    let deliveryStatusObj = {};
    editProData.proNumber = proId;
    const shipmentObj = this.getShipmentData(proId);
    const payment = isPaymentDetailsRequired({
      deliveryStatus: editInfo.deliveryStatus,
      codAmount: shipmentObj?.codAmount,
      freightAmount: shipmentObj?.freightAmount,
    });
    if (payment) {
      deliveryStatusObj.payment = this.getPaymentDetailsObject(editInfo);
    }
    if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DC) {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
    } else if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DE) {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
      deliveryStatusObj.exception = this.props.deliveryException.getExceptionRequestPayload(
        editInfo.exception
      );
    } else if (editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN) {
      const returnExceptionPayload = this.props.deliveryException.getExceptionRequestPayload(
        editInfo.exception,
        true
      );
      // getExceptionRequestPayload returns an array of exception details, we need to get the first exception detail
      const firstReturnException = returnExceptionPayload?.length > 0 ? returnExceptionPayload[0] : null;
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
      deliveryStatusObj.return = {
        returnCode: editInfo.returnCode,
        customerName: editInfo.customerName,
        ...firstReturnException
      };
    } else {
      deliveryStatusObj.deliveryCode = editInfo.deliveryStatus;
    }
    editProData = { ...editProData, ...deliveryStatusObj };
    editProData.accessorials = [...this.getAccessorialsArray(editInfo)];
    if (isLiftgateChecked(editInfo.accessorials, appConstants.ACCESSORIAL.LIMITED_ACCESS)) {
      editProData.limitedAccessCode = editInfo.limitedAccessCode;
    }
    if (isLiftgateChecked(editInfo.accessorials, appConstants.ACCESSORIAL.LIFTGATE)) {
      editProData.liftgateReasonCode = editInfo.liftgateReasonCode;
    }
    if (
      this.props.configJSON?.enableSortAndSegregatePieces &&
      isSortAndSegregateChecked(editInfo.accessorials, appConstants.ACCESSORIAL.SORT_AND_SEGREGATE) &&
      editInfo.sortAndSegregatePieces > 0
    ) {
      editProData.sortAndSegregatePieces = Number(editInfo.sortAndSegregatePieces);
    }
    editProData.isShrinkWrap = editInfo.isShrinkWrap ?? null;
    editProData.isPhysicalPiecesChanged = editInfo.isPhysicalPiecesChanged ?? false;
    editProData.palletCount = editInfo.palletCount
      ? parseInt(editInfo.palletCount)
      : null;
    editProData.physicalPiecesHandled = editInfo.physicalPiecesHandled
      ? parseInt(editInfo.physicalPiecesHandled)
      : null;
    editProData.excessiveLength = editInfo.excessiveLength ? editInfo.excessiveLength : null;
    editProData.excessiveLengthInches = editInfo.excessiveLengthInches ? editInfo.excessiveLengthInches : null;

    return { editProData, shipmentData: this.getShipmentData(proId) };
  };

  hasError = (errorInfo) => {
    const error = Object.values(errorInfo).filter((value) => value).length;
    return error > 0;
  };

  getFirstProMarkedTAOrSND = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.find((pro) =>
      [appConstants.DELIVERY_CODE.TA, appConstants.DELIVERY_CODE.SND].includes(
        pro.editInfo.deliveryStatus
      )
    );
  };

  allProsHaveSameStatus = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) =>
        pro.editInfo.deliveryStatus ===
        editBillsDataArray[0].editInfo.deliveryStatus
    );
  };

  allProsMarkedAsReturn = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN
    );
  };

  allProsMarkedAsSND = () => {
    const { editBillsDataArray } = this.state;
    return editBillsDataArray.every(
      (pro) => pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.SND
    );
  };

  getProcessDeliveryUpdatedData = () => ({
    editBillsDataArray: this.state.editBillsDataArray,
    allStatusRadioClicked: this.state.allStatusRadioClicked,
    isDriverAllowedInside: this.state.isDriverAllowedInside,
    stopTimeInfo: this.state.stopTimeInfo,
  });

  getConfirmButtonTitle = () =>{
    if (this.allProsMarkedAsReturn()) {
      return "Update Return";
    }

    if (this.allProsMarkedAsSND()) {
      return "Update Delivery";
    }

    return "Create Delivery Receipt";
  }

  submitProData = () => {
    const stopTimeDetailsInfo = this.state.isArrivalDepartureTimeRequired
      ? getStopTimeErrorInfo(this.state.stopTimeInfo.stopTime)
      : getDefaultStopTimeInfo();

    this.setState({
      stopTimeInfo: stopTimeDetailsInfo,
    });
    const proMarkedTAorSND = this.getFirstProMarkedTAOrSND();
    if (
      this.isMultipleBillStop() &&
      !this.allProsHaveSameStatus() &&
      proMarkedTAorSND
    ) {
      this.setState({
        showConfirmDialog: true,
        allProDelStatusLabel: this.getDeliveryStatus(
          proMarkedTAorSND.editInfo.deliveryStatus
        ),
        allProDelStatusCode: proMarkedTAorSND.editInfo.deliveryStatus,
      });
      return;
    }
    const errorInfo = this.getErrorInfo();
    const finalDeliveryInfoList = [];
    const editBillsWithValError = [];
    errorInfo.forEach((errorInfoObj) => {
      const error = Object.values(errorInfoObj.errorInfo).filter(
        (value) => value
      ).length;
      error
        ? editBillsWithValError.push(
            this.inputRefs.find((ref) => ref.id === errorInfoObj.proId)
          )
        : finalDeliveryInfoList.push(this.populateRequestObj(errorInfoObj));
    });
    const isValError = editBillsWithValError.length > 0;
    const isStopTimeValError = this.state.isArrivalDepartureTimeRequired
      ? isStopTimeDetailsInValid(stopTimeDetailsInfo)
      : false;
    if (!isValError && !isStopTimeValError) {
      const proData = this.state.editStopsList.map((stop) => {
        const deliveryInfo =
          stop.stopId === this.props.stopData.stopId
            ? [...finalDeliveryInfoList]
            : [...this.getOtherStopsData(stop)];
        return {
          stop,
          deliveryInfo: deliveryInfo,
        };
      });
      this.props.submitProData({
        processDeliveryData: this.getProcessDeliveryUpdatedData(),
        proData,
        stopTimeDetails: this.state.stopTimeInfo,
        isDriverAllowedInside: this.state.isDriverAllowedInside,
        allProsMarkedTA: this.allProsMarkedTA(),
        isReturn: this.allProsMarkedAsReturn() || this.allProsMarkedAsSND(),
      });
    } else {
      editBillsWithValError[0]?.scrollIntoView({
        block: "start",
        behavior: "smooth",
      });
    }
  };

  isSelectedOSNDException = (editInfo) => {
    return editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DE
  };

  isSelectedReturnCodeException = (editInfo) => {
    return this.props.DispatchStore.getReturnDetails(editInfo.returnCode)
      ?.isException;
  };

  validateExceptionDetails = (editInfo) => {
    const isReturn = this.isSelectedReturnCodeException(editInfo);
    const isOSND = this.isSelectedOSNDException(editInfo);
    if (isReturn || isOSND) {
      return this.props.deliveryException.validateExceptionDetail(editInfo.exception, isReturn);
    }
    return null;
  };

  getFieldError = (proId, field, value) => {
    const { editBillsDataArray } = this.state;
    const { length: trailerLength } = this.props.routeData.trailer;
    let valueTrim;
    if (field !== "accessorials") {
      valueTrim = value;
    }
    const matchedProEditInfo = editBillsDataArray.find(
      (pro) => pro.proId === proId
    )?.editInfo;
    const shipmentObj = this.getShipmentData(proId);
    const paymentErrInfo = getPaymentErrorInfo({
      data: {
        deliveryStatus: matchedProEditInfo.deliveryStatus,
        freightPaymentType: matchedProEditInfo.freightPaymentType,
        freightAmount: shipmentObj?.freightAmount,
        codAmount: shipmentObj?.codAmount,
      },
      field,
      value: valueTrim,
    });
    if (matchedProEditInfo) {
      const isLimitedAccessChecked =
        matchedProEditInfo.accessorials.length > 0
          ? matchedProEditInfo.accessorials.find(
              (ele) => ele.name === appConstants.ACCESSORIAL.LIMITED_ACCESS
            )?.isChecked
          : false;
      switch (field) {
        case "deliveryStatus":
          return valueTrim ? null : "* Delivery Status is required";
        case "limitedAccessCode":
          return isLimitedAccessChecked &&
            matchedProEditInfo.deliveryStatus !== appConstants.DELIVERY_CODE.RTN
            ? value
              ? null
              : "* Limited Access is required"
            : null;
        case "liftgateReasonCode":
          return getDeliveryLiftgateReasonValidationError(
            this.props.configJSON,
            matchedProEditInfo,
            value
          );
        case "returnCode":
          return matchedProEditInfo.deliveryStatus ===
            appConstants.DELIVERY_CODE.RTN
            ? valueTrim
              ? null
              : "* Return Code is required"
            : null;
        case "palletCount":
          if (!this.props.configJSON?.enableShrinkWrapOption) {
            return null;
          }
          return valueTrim || !matchedProEditInfo.isShrinkWrap
            ? null
            : "* Required";
        case "physicalPiecesHandled":
          return getPhysicalPiecesValidationError({
            enableChangeInPhysicalPiecesOption: Boolean(this.props.configJSON?.enableChangeInPhysicalPiecesOption),
            isPhysicalPiecesChanged: Boolean(matchedProEditInfo.isPhysicalPiecesChanged),
            value: valueTrim
          });
        case 'excessiveLength': {
          if (!this.props.configJSON?.enableExcessiveLengthOption) {
            return null;
          }
          const { shouldShowExcessiveLength } = this.getDeliveryStatusFlags(proId);
          if (
            !shouldShowExcessiveLength ||
            [
              appConstants.EXCESSIVE_SHIPMENT.NO,
              appConstants.EXCESSIVE_SHIPMENT.CAN_NOT_SEE
            ].includes(matchedProEditInfo.isExcessiveLength)
          ) {
            return null;
          }
          const maxExcessiveLength = this.props.DispatchStore.getExcessiveLengthMaxLimit(trailerLength);
          return getExcessiveLengthError(valueTrim, maxExcessiveLength);
        }
        case "customerName":
          return appConstants.SPECIAL_RETURNS.includes(
            matchedProEditInfo.returnCode
          )
            ? valueTrim
              ? null
              : "* Customer Name is required"
            : null;
        case "accessorials":
          return this.validateDeliveryAccessorials(value, matchedProEditInfo.deliveryStatus) ? null : MESSAGES.PROCESS_DELIVERY.ACCESSORIAL_REQUIRED;
        case "sortAndSegregatePieces":
          return getDeliverySortAndSegregateValidationError({
            enableSortAndSegregatePieces: Boolean(this.props.configJSON?.enableSortAndSegregatePieces),
            editInfo: matchedProEditInfo,
            value
          });
        case "freightPaymentType":
        case "freightCheckNumber":
        case "freightAmount":
        case "codPaymentType":
        case "codCheckNumber":
        case "codAmount":
          return paymentErrInfo;
        default:
          return null;
      }
    }
  };

  validateDeliveryAccessorials = (value, deliveryStatus) => {
    return deliveryStatus !== appConstants.DELIVERY_CODE.RTN &&
      this.props.configJSON.deliveryAccessorialRequired
      ? value?.some((option) => option?.isChecked)
      : true;
  };

  getErrorInfo = () => {
    const validatedBillsData = [];
    this.state.editBillsDataArray.forEach((pro) => {
      const errorInfo = {};
      Object.keys(pro.editInfo).forEach((fieldName) => {
        if (fieldName === 'exception') {
          // validateExceptionDetails returns the exception details array including error information if validation fails, or null if all exceptions are valid
          const exceptionsWithErrors = this.validateExceptionDetails(pro.editInfo);
          if (exceptionsWithErrors) {
            pro.editInfo.exception = exceptionsWithErrors;
            
            // Set error flag to true to block further form submission
            errorInfo[fieldName] = true;
          }
          return;
        }
        errorInfo[fieldName] = this.getFieldError(
          pro.proId,
          fieldName,
          fieldName === 'excessiveLength'
            ? getCombinedExcessiveLength(pro.editInfo.excessiveLength, pro.editInfo.excessiveLengthInches)
            : pro.editInfo[fieldName]
        );
      });
      validatedBillsData.push({ ...pro, errorInfo: errorInfo });
    });
    this.setState({ editBillsDataArray: validatedBillsData });
    return validatedBillsData;
  };

  isMultipleBillStop = () => {
    return this.state.editBillsDataArray.length > 1;
  };

  getShipmentData = (proId) => {
    return this.props.stopData.shipments.find(
      (shipmentData) => shipmentData.proId === proId
    );
  };

  handleStatusForAllPros = (name) => (value) => {
    const updatedEditInfoArr = [];
    const isReturnStatus = name === "deliveryStatus" && value === appConstants.DELIVERY_CODE.RTN;
    
    this.state.editBillsDataArray.forEach((pro) => {
      if (
        pro.editInfo.deliveryStatus === value ||
        !pro.editInfo.deliveryStatus
      ) {
        let editInfo = {
          ...pro.editInfo,
          [name]: value,
        };
        
        if (isReturnStatus) {
          editInfo.returnCode = "";
          editInfo.customerName = null;
          editInfo.exception = this.props.deliveryException.getDefaultExceptionDetail();
        }
        
        updatedEditInfoArr.push({ ...pro, errorInfo: {}, editInfo: editInfo });
      } else {
        updatedEditInfoArr.push({ ...pro });
      }
    });
    this.setState({
      editBillsDataArray: updatedEditInfoArr,
      allStatusRadioClicked: true,
    });
  };

  updateAllReturnShipments = (updateEditInfo, updateErrorInfo) => {
    const updatedEditInfoArr = this.state.editBillsDataArray.map((pro) => {
      if (pro.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN) {
        const editInfo = updateEditInfo(pro.editInfo);
        const errorInfo = updateErrorInfo
          ? updateErrorInfo(pro.errorInfo, pro.proId, editInfo)
          : pro.errorInfo;
        return { ...pro, editInfo, errorInfo };
      }
      return pro;
    });
    this.setState({ editBillsDataArray: updatedEditInfoArr });
  };

  handleGlobalReturnCodeChange = (returnCode) => {
    const returnCodeValue = returnCode?.value || returnCode;
    this.updateAllReturnShipments(
      (editInfo) => ({
        ...editInfo,
        returnCode: returnCodeValue,
        customerName: appConstants.SPECIAL_RETURNS.includes(returnCodeValue)
          ? editInfo.customerName
          : null,
        exception: this.props.deliveryException.getDefaultExceptionDetail(),
      }),
      (errorInfo, proId) => ({
        ...errorInfo,
        returnCode: this.getFieldError(proId, "returnCode", returnCodeValue),
      })
    );
  };

  handleGlobalCustomerNameChange = (customerName) => {
    this.updateAllReturnShipments(
      (editInfo) => ({
        ...editInfo,
        customerName: customerName,
      }),
      (errorInfo, proId) => ({
        ...errorInfo,
        customerName: this.getFieldError(proId, "customerName", customerName),
      })
    );
  };

  handleGlobalExceptionChange = (name) => (value) => {
    this.updateAllReturnShipments(
      (editInfo) => ({
        ...editInfo,
        [name]: value,
      }),
      (errorInfo, _proId, editInfo) => ({
        ...errorInfo,
        exception:
          name === "exception"
            ? this.validateExceptionDetails(editInfo)
            : errorInfo.exception,
      })
    );
  };

  isDeliveryStatusUpdated = () => {
    return this.state.editBillsDataArray.some(
      (pro) => pro.editInfo.deliveryStatus
    );
  };

  handleGlobalChange = (name) => (value) => {
    if (name === "returnCode") {
      this.handleGlobalReturnCodeChange(value);
    } else if (name === "customerName") {
      this.handleGlobalCustomerNameChange(value);
    } else {
      this.handleGlobalExceptionChange(name)(value);
    }
  };

  /* Changes related to this logic should sync with driver app behavior */
  getDeliveryStatusFlags = (proId) => {
    const { editInfo } = this.state.editBillsDataArray.find(bill => bill.proId === proId);
    const shipmentData = this.getShipmentData(proId);
    const isReturnDelivery = appConstants.DELIVERY_CODE.RTN === editInfo.deliveryStatus;
    const isSNDDelivery = appConstants.DELIVERY_CODE.SND === editInfo.deliveryStatus;
    const isTADelivery = editInfo.deliveryStatus === appConstants.DELIVERY_CODE.TA;
    const isDEDelivery = editInfo.deliveryStatus === appConstants.DELIVERY_CODE.DE;
    const isReturnOrSNDDelivery = isReturnDelivery || isSNDDelivery;
    const shouldShowExcessiveLength =
      !isReturnOrSNDDelivery &&
      ((!this.props.stopData.isStopCompleted &&
        shipmentData.excessiveLength !== appConstants.EXCESSIVE_SHIPMENT.YES) ||
        this.props.stopData.isStopCompleted);

    return {
      isReturnDelivery,
      isTADelivery,
      isDEDelivery,
      isReturnOrSNDDelivery,
      shouldShowExcessiveLength
    };
  };

  render() {
    const {
      classes,
      handleClose,
      stopData,
      routeData,
      freightBillData,
      isDriverArrived,
    } = this.props;
    const { editBillsDataArray } = this.state;
    const deliveryStatusList = this.props.DispatchStore.deliveryStatuses;
    const stopHasMultiplePros = this.isMultipleBillStop();
    const allProsMarkedAsReturn = this.allProsMarkedAsReturn();
    const firstReturnPro = allProsMarkedAsReturn
      ? editBillsDataArray.find(
          (bill) => bill.editInfo.deliveryStatus === appConstants.DELIVERY_CODE.RTN
        )
      : null;
    return (
      <React.Fragment>
        <div className={classes.processDeliveryContent}>
          <StopDetailsTitle
            stopData={stopData}
            driverNumber={routeData?.driverNumber}
          />
          <SwitchWithLabel
            rowLabel="Is driver allowed inside to complete delivery?"
            onChange={this.handleIsDriverAllowedChange}
            value={this.state.isDriverAllowedInside}
          />

          {!stopHasMultiplePros && !this.state.showDeliveryReceipt && (
            <React.Fragment>
              <ShipmentDetails
                shipmentData={stopData.shipments[0]}
                freightBillDetails={getShipmentFreightBill(
                  freightBillData,
                  editBillsDataArray[0].proId
                )}
              />
              <Form
                stopHasMultiplePros={stopHasMultiplePros}
                forwardRef={this.setRef}
                editInfo={editBillsDataArray[0].editInfo}
                updateStop={this.props.updateStop}
                routeData={routeData}
                stopData={stopData}
                shipmentData={stopData.shipments[0]}
                errorInfo={editBillsDataArray[0].errorInfo}
                handleChange={this.handleChange(editBillsDataArray[0].proId)}
                clearSelections={this.clearSelections}
                updateStopSelection={this.updateStopSelection}
                getDeliveryStatusFlags={this.getDeliveryStatusFlags}
              >
                <StopWindowDetails
                  disabled={!this.state.isArrivalDepartureTimeRequired}
                  arrivalTime={this.state.stopTimeInfo.stopTime.arrivalTime}
                  isArrivalTimeDisabled={isDriverArrived}
                  departureTime={this.state.stopTimeInfo.stopTime.departureTime}
                  arrivalTimeError={
                    this.state.stopTimeInfo.stopTimeError.arrivalTime
                  }
                  departureTimeError={
                    this.state.stopTimeInfo.stopTimeError.departureTime
                  }
                  handleChange={this.handleStopTimeChange}
                  timeWindow={formatDeliveryOrServiceWindow(stopData.deliveryWindow)}
                  timeWindowLabel="Delivery Window"
                />
              </Form>
            </React.Fragment>
          )}
          {stopHasMultiplePros && !this.state.showDeliveryReceipt && (
            <div>
              <h4
                className={classes.deliveryBillsHeaderText}
              >{`Delivery Bills: ${stopData.numberOfBills}`}</h4>
              {editBillsDataArray.map((bill) => {
                const shipmentDataMulti = this.getShipmentData(bill.proId);
                return (
                  <ShipmentCard
                    stopHasMultiplePros={stopHasMultiplePros}
                    shipmentData={shipmentDataMulti}
                    forwardRef={this.setRef}
                    key={`shipment_card_${shipmentDataMulti.proId}`}
                    stopData={stopData}
                    editInfo={bill.editInfo}
                    routeData={routeData}
                    errorInfo={bill.errorInfo}
                    handleChange={this.handleChange}
                    deliveryStatusList={deliveryStatusList}
                    clearSelections={this.clearSelections}
                    deliveryStatus={{
                      deliveryStatus: bill.editInfo.deliveryStatus,
                      hasError: this.hasError(bill.errorInfo),
                    }}
                    freightBillDetails={getShipmentFreightBill(
                      freightBillData,
                      bill.proId
                    )}
                    getDeliveryStatusFlags={this.getDeliveryStatusFlags}
                    onExpandChange={this.handleProFormExpand}
                  />
                );
              })}
              {!this.isDeliveryStatusUpdated() &&
                !this.state.allStatusRadioClicked && (
                  <StyledRadioGroup
                    onChange={this.handleStatusForAllPros("deliveryStatus")}
                    options={deliveryStatusList.filter(
                      (list) =>
                        list.value !== appConstants.DELIVERY_CODE.DE
                    )}
                    headerLabel="DELIVERY STATUS"
                  />
                )}
              <StopWindowDetails
                disabled={!this.state.isArrivalDepartureTimeRequired}
                arrivalTime={this.state.stopTimeInfo.stopTime.arrivalTime}
                isArrivalTimeDisabled={isDriverArrived}
                departureTime={this.state.stopTimeInfo.stopTime.departureTime}
                arrivalTimeError={
                  this.state.stopTimeInfo.stopTimeError.arrivalTime
                }
                departureTimeError={
                  this.state.stopTimeInfo.stopTimeError.departureTime
                }
                handleChange={this.handleStopTimeChange}
                timeWindow={formatDeliveryOrServiceWindow(stopData.deliveryWindow)}
                timeWindowLabel="Delivery Window"
              />
              {this.allProsMarkedTA() && (
                <SelectBills
                  stopsList={getPendingStops(routeData.stops)}
                  currentStopData={stopData}
                  updateStopSelection={this.updateStopSelection}
                />
              )}
              {allProsMarkedAsReturn &&
                this.state.allStatusRadioClicked &&
                !this.state.hasAnyProFormBeenOpened &&
                firstReturnPro && (
                  <ReturnDetails
                    editInfo={firstReturnPro.editInfo}
                    errorInfo={firstReturnPro.errorInfo}
                    onChange={this.handleGlobalChange}
                    isReturnDelivery={true}
                    deliveryException={this.props.deliveryException}
                    isDEDelivery={false}
                  />
                )}
            </div>
          )}
        </div>
        <Action
          confirmButtonText={this.getConfirmButtonTitle()}
          isDisabled={
            allProsMarkedAsReturn && this.props.isProcessDeliveryInProgress
          }
          handleClose={handleClose}
          handleSubmit={this.submitProData}
        />
        {this.state.showConfirmDialog && (
          <CustomConfirmationDialog
            title={`All Pros ${this.state.allProDelStatusLabel}`}
            cancelButtonLabel="Cancel"
            confirmButtonLabel="Update All"
            onConfirm={this.submitAllProsOnConfirm}
            onCancel={this.cancelStopCompletion}
          >
            <div className={classes.confirmDialogContent}>
              <span>
                {`This action will update delivery statuses for all bills to ${this.state.allProDelStatusLabel}.`}
              </span>
              <span>Do you want to update all Pros?</span>
            </div>
          </CustomConfirmationDialog>
        )}
      </React.Fragment>
    );
  }
}

export default compose(
  withUserProfile,
  withStyles(styles),
  withSnackbar,
  withAppConfig
)(withExceptionDetailsHOC(ProcessDelivery));
